__turbopack_context__.v({
  "caseContent": "style-module-scss-module__NtfqwG__caseContent",
  "caseDescription": "style-module-scss-module__NtfqwG__caseDescription",
  "caseImage": "style-module-scss-module__NtfqwG__caseImage",
  "caseImageWrap": "style-module-scss-module__NtfqwG__caseImageWrap",
  "caseStudy": "style-module-scss-module__NtfqwG__caseStudy",
  "caseTitle": "style-module-scss-module__NtfqwG__caseTitle",
});
